import { HttpService } from '@/utils/http/index'

const $http = new HttpService()

/**
 * 获取发票列表
 * @param params
 */
export const getInvoiceListApi = (params:object) => $http.get('/invoice/invoice_finance_check_list', params)

/**
 * 获取发票详情
 * @param params
 *      id：发票 id
 */
export const getInvoiceDetailApi = (id:any) => $http.post('/invoice/get_invoice_info', {id})

/**
 * 新增/编辑发票
 * @param data
 *  invoice_name：发票标题内容
 *  invoice_info：发票详情
 *  submit_type：保存类型：0-保存，1-提交审核
 */
export const saveInvoiceApi = (data:object) => $http.post('/invoice/invoice_add', {invoice_info: data})

/**
 * 上传发票
 * @param data
 */
export const upInvoiceApi = (data:object) => $http.post('/invoice/uploadInvoice', data)

/**
 * 发票审核
 * @param data
 *  id：审核记录ID
 *  type：审核结果，2-通过，3-驳回，4-已收到
 *  remark：驳回原因
 */
export const checkInvoiceApi = (data:object) => $http.post('/invoice/invoice_finance_check', data)

/**
 * 账务端获取预付款回传单列表
 */
export const getBankReceiptListApi = (params: object) => $http.get('/admin/channel/finance_bank_receipt_list', { ...params })

/**
 * 渠道端获取预付款回传单列表
 */
export const getBankReceiptListByChannelApi = (params: object) => $http.get('/admin/channel/channel_bank_receipt_list', params)

/**
 * 渠道端获取预付款剩余余额
 */
export const getReceiptListByChannelApi = (params: object) => $http.get('/admin/channel/get_channel_money', params)

/**
 * 渠道上传预付款回传单数据
 */
export const saveBankReceiptApi = (data: object) => $http.post('/admin/channel/set_channel_remain_money', data)

/**
 * 获取渠道预付款回传单详情
 */
export const getBankReceiptDetailApi = (id: object) => $http.get('/admin/channel/channel_bank_receipt_info', { id })

/**
 * 预付款审核
 * @param data
 *  id：审核记录ID
 *  type：审核结果，1-通过，2-驳回
 *  remark：驳回原因
 */
export const checkPrepayApi = (data:object) => $http.post('/admin/channel/finance_to_examine', data)
